export default {
  MARGIN_LEFT: 40,
  MARGIN_LEFT_WITH_LEGEND: 56,
  MARGIN_RIGHT: 12, // Accounts for overflowing x axis labels
  MARGIN_TOP: 12, // Accounts for overflowing y axis labels
  MARGIN_BOTTOM: 64,
  MARGIN_BOTTOM_WITH_LEGEND: 72,
}
